import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface ProblemSectionProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function ProblemSection({ onOpenWhatsApp }: ProblemSectionProps) {
  return (
    <section id="hizmetler" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="reveal w-full lg:w-1/2">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20catering%20staff%20in%20black%20uniforms%20serving%20fresh%20hot%20meals%20in%20stainless%20steel%20trays%20to%20factory%20workers%20in%20industrial%20dining%20area%20bright%20clean%20hygienic%20wide%20angle%20photography&width=1200&height=700&seq=problem-1&orientation=landscape"
                alt="Profesyonel toplu yemek hizmeti"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          </div>

          <div className="reveal w-full lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-6">
              YEMEK ORGANİZASYONU
              <br />
              AYRI BİR İŞ YÜKÜ OLMASIN
            </h2>
            <p className="font-body text-foreground-700 text-base md:text-lg leading-relaxed mb-4">
              Çalışanlarınızın günlük yemek ihtiyacını planlamak, hazırlamak ve
              düzenli şekilde servis etmek ciddi bir operasyon gerektirir.
            </p>
            <p className="font-body text-foreground-700 text-base md:text-lg leading-relaxed mb-8">
              Kaya Catering, toplu yemek sürecini işletmeniz adına profesyonel
              şekilde yönetir.
            </p>
            <button
              onClick={() => onOpenWhatsApp()}
              className="btn-primary"
            >
              İhtiyacımı Anlat
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}